<template>
  <div>
    <div class="container py-lg-5 py-md-3">
      <div class="row">
        <div
          class="
            col-lg-12
            about-right-faq
            align-self
            mb-lg-0 mb-sm-5 mb-4
            pr-lg-5
          "
        >
          <div class="header-title mb-md-5 mb-4">
            <span class="sub-title">发展历程</span>
          </div>
          <div class="mt-md-0 mt-md-5 mt-4">
            <div style="width:90%;margin:auto;">
              <!-- <h5 class="text-center">
                  设立背景
                </h5> -->
              <p v-html="datatext" class="mt-3 ql-editor">

              </p>
            </div>
            <div class="timeaxis">
              <div class="content">
                <history-time></history-time>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import historyTime from "@/views/about/history_time.vue"
export default {
    components: {
        historyTime
  },
 props:{
   datatext:{
     type:String,
     default:""
   }
 },
  data() {
    return {
      timeList: [
        
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.mt-3 ,p{
  letter-spacing: 0.2em;
  line-height: 2.6em;
  text-indent: 40px;
  color: #666;
}
.bigTitle {
  width: 100%;
  height: 60px;
  margin: auto;
  ul li {
    width: 50%;
    display: block;
    float: left;
    line-height: 60px;
    font-size: 20px;
    cursor: pointer;
  }
  ul li:hover {
    color: #00758e;
    font-size: 22px;
  }
  ul li:last-child {
    text-align: left;
  }
  ul li:first-child {
    text-align: right;
  }
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 24px;
  opacity: 0.75;
  margin: 0;
  line-height: 40px;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.timeLine {
  width: 100%;
  height: auto;
  margin: auto;
}
.content {
  width: 88%;
  height: auto;
  margin: auto;
}

</style>